import { render } from "./Credential.vue?vue&type=template&id=f5d382b6"
import script from "./Credential.vue?vue&type=script&lang=js"
export * from "./Credential.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__